import {
  Cpu,
  HardDrive,
  Shield,
  Sparkles,
  Stethoscope,
  Wifi,
  type LucideIcon,
} from "lucide-react";
import { useSiteContent } from "../../lib/content";
import type { ServiceItem } from "../../types";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";
import { Container, Section } from "../ui/Container";
import { SectionHeading } from "../ui/SectionHeading";

const icons: Record<ServiceItem["icon"], LucideIcon> = {
  stethoscope: Stethoscope,
  cpu: Cpu,
  sparkles: Sparkles,
  shield: Shield,
  hardDrive: HardDrive,
  wifi: Wifi,
};

export function Services() {
  const { content } = useSiteContent();
  const { services } = content;

  return (
    <Section id="servicos" labelledBy="servicos-title" className="bg-surface/40">
      <Container>
        <SectionHeading id="servicos-title" title={services.heading} subtitle={services.subtitle} />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.items.map((service) => {
            const Icon = icons[service.icon] ?? Cpu;
            return (
              <Card key={service.id} as="article">
                <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg border border-primary/30 bg-primary/10 text-primary">
                  <Icon className="h-5 w-5" aria-hidden />
                </div>
                <h3 className="font-heading text-lg font-semibold text-primary">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted">{service.description}</p>
                <p className="mt-4 text-xs uppercase tracking-wide text-accent-terminal">
                  Tempo médio: {service.duration}
                </p>
              </Card>
            );
          })}
        </div>

        <div className="mt-12 rounded-2xl border border-primary/25 bg-background px-6 py-8 text-center md:px-10">
          <p className="font-heading text-2xl font-semibold text-primary">{services.ctaTitle}</p>
          <p className="mt-2 text-muted">{services.ctaText}</p>
          <Button href="#contacto" className="mt-6">
            {content.hero.ctaPrimary}
          </Button>
        </div>
      </Container>
    </Section>
  );
}
